<template>
  <div class="bindsuccess">
    <p class="check_title">{{$t('boundEmail')}}:</p>
    <p>{{email}}</p>
    <van-button class="back_btn" type="danger" block round @click="backPage">
      {{$t('return')}}
    </van-button>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'BindSuccess',
  data(){
    return{
      email: '',
      accessToken: localStorage.getItem('accessToken'),
      appId: localStorage.getItem('appId'),
    }
  },
  created(){
    this.email = this.$route.query.email
  },
  methods:{
    ...mapActions(['getUserPayEmail']),
    backPage(){
      if(this.$route.query.from == 'paylogin'){
        this.$router.push({
          path: '/paylogin'
        });
      } else {
        this.$router.push({
          path: '/store'
        });
      }
    }
  },
  computed:{
    ...mapGetters(['peData', 'peStatus'])
  },
  mounted(){
    this.getUserPayEmail({
      accessToken: this.accessToken,
      appId: this.appId,
      uid: window.localStorage.getItem('uid')
    })
    this.$watch('peStatus', val => {
      if(val == 'stated'){
        this.email = this.peData.payEmail
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.bindsuccess{
  margin: 20px;
  p{
    margin: 5px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    &.check_title{
      margin-top: 50px;
      font-size: 12px;
      color: #c7c7c7;
    }
  }
  .back_btn{
        margin-top: 50px;
        width: 90%;
        left: 5%;
        padding: 15px;
  }
}
</style>